/** 节点组：master/worker、系统盘、副本数 */
export const MAAS_NODE_GROUPS_FIELD_KEYS = {
  runMode: 'mi.runMode',
  masterNodes: 'mi.masterNodes',
  workerNodes: 'mi.workerNodes',
  masterSystemDisk: 'mi.masterSystemDisk',
  workerSystemDisk: 'mi.workerSystemDisk',
  replicas: 'mi.replicas',
} as const;

export const MAAS_GATEWAY_NODES_FIELD_KEYS = {
  gatewayNodes: 'mi.gatewayNodes',
  gatewaySystemDisk: 'mi.gatewaySystemDisk',
} as const;

export const MAAS_NODE_GROUPS_FIELD_KEY_LIST = [
  MAAS_NODE_GROUPS_FIELD_KEYS.runMode,
  MAAS_NODE_GROUPS_FIELD_KEYS.masterNodes,
  MAAS_NODE_GROUPS_FIELD_KEYS.workerNodes,
  MAAS_NODE_GROUPS_FIELD_KEYS.masterSystemDisk,
  MAAS_NODE_GROUPS_FIELD_KEYS.workerSystemDisk,
  MAAS_NODE_GROUPS_FIELD_KEYS.replicas,
] as const;

export const MAAS_GATEWAY_NODES_FIELD_KEY_LIST = [
  MAAS_GATEWAY_NODES_FIELD_KEYS.gatewayNodes,
  MAAS_GATEWAY_NODES_FIELD_KEYS.gatewaySystemDisk,
] as const;
